var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"p-topNotice"},[_c('div',{staticClass:"l-container"},[_c('h2',{directives:[{name:"t",rawName:"v-t",value:('お知らせ'),expression:"'お知らせ'"}],staticClass:"p-topNotice__title"}),_c('p',{staticClass:"p-topNotice__description content"},[_vm._v(" "+_vm._s(this.noticeText)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }